<div class="centered-dialog">
    <form>
        <je-list (selectionChanged)="onSelectionChanged($event)" [items]="partners$ | async" label="{{ 'PARTNERSELECTION.SELECTPARTNERLABEL' | translate }}">
            <ng-template let-partner>
                <div class="p-2 rounded text-black-900 dark:text-gray-300 border border-solid border-black-500 text-left hover:bg-blue hover:text-white">{{ partner.name }}</div>
            </ng-template>
        </je-list>
    </form>
</div>
